export interface NotificationItem {
  id: number;
  type: 'appointment' | 'payment' | 'system' | 'package' | 'warning' | 'staff';
  title: string;
  description: string;
  timestamp: string;
  read: boolean;
  link?: string;
  count?: number;
}

export const notifications: NotificationItem[] = [
  {
    id: 1,
    type: 'appointment',
    title: 'Yeni Randevu Alındı',
    description: 'Ahmet Yılmaz — Masaj Seansı, 14:30',
    timestamp: '2 dk önce',
    read: false,
    link: '/randevular',
  },
  {
    id: 2,
    type: 'payment',
    title: 'Ödeme Tamamlandı',
    description: 'Ayşe Demir — ₺450 nakit tahsilat',
    timestamp: '5 dk önce',
    read: false,
    link: '/kasa',
  },
  {
    id: 3,
    type: 'warning',
    title: 'Randevu İptali',
    description: 'Mehmet Kaya saat 16:00 randevusunu iptal etti',
    timestamp: '12 dk önce',
    read: false,
    link: '/randevular',
  },
  {
    id: 4,
    type: 'package',
    title: 'Paket Seansı Azaldı',
    description: 'Zeynep Şahin paketinde 1 seans kaldı',
    timestamp: '18 dk önce',
    read: true,
    link: '/paketler',
  },
  {
    id: 5,
    type: 'system',
    title: 'Günlük Rapor Hazır',
    description: 'Dünkü işletme raporu oluşturuldu',
    timestamp: '30 dk önce',
    read: true,
    link: '/raporlar',
  },
  {
    id: 6,
    type: 'staff',
    title: 'Personel Girişi',
    description: 'Burak Tekin saat 08:45\'te giriş yaptı',
    timestamp: '45 dk önce',
    read: true,
  },
  {
    id: 7,
    type: 'payment',
    title: 'Açık Ödeme Hatırlatma',
    description: 'Hakan Mert\'ten ₺230 tahsilat bekleniyor',
    timestamp: '1 saat önce',
    read: false,
    link: '/kasa',
  },
  {
    id: 8,
    type: 'appointment',
    title: 'Randevu Teyiti Gerekiyor',
    description: '3 randevu için teyit mesajı gönderilmedi',
    timestamp: '2 saat önce',
    read: true,
    link: '/randevular',
    count: 3,
  },
];